export default function DontIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clipPath='url(#clip0_3255_10642)'>
        <path
          d='M12.9506 3.05124C12.3018 2.39598 11.5299 1.87538 10.6792 1.51934C9.82856 1.1633 8.91594 0.978853 7.99379 0.976584C7.07164 0.974314 6.15813 1.15427 5.30574 1.50611C4.45335 1.85796 3.67888 2.37475 3.02681 3.02681C2.37475 3.67888 1.85796 4.45335 1.50611 5.30574C1.15427 6.15813 0.974314 7.07164 0.976584 7.99379C0.978853 8.91594 1.1633 9.82856 1.51934 10.6792C1.87538 11.5299 2.39598 12.3018 3.05124 12.9506C3.70008 13.6059 4.472 14.1265 5.32265 14.4825C6.1733 14.8386 7.08591 15.023 8.00806 15.0253C8.93021 15.0275 9.84373 14.8476 10.6961 14.4957C11.5485 14.1439 12.323 13.6271 12.975 12.975C13.6271 12.323 14.1439 11.5485 14.4957 10.6961C14.8476 9.84373 15.0275 8.93021 15.0253 8.00806C15.023 7.08591 14.8386 6.1733 14.4825 5.32265C14.1265 4.472 13.6059 3.70008 12.9506 3.05124ZM13.5009 8.00093C13.5021 9.20051 13.109 10.3672 12.3822 11.3216L4.6803 3.61968C5.63461 2.89284 6.80134 2.49975 8.00093 2.50093C11.0337 2.50093 13.5009 4.96968 13.5009 8.00093ZM2.50093 8.00093C2.49975 6.80134 2.89284 5.63461 3.61968 4.6803L11.3216 12.3822C10.3672 13.109 9.20051 13.5021 8.00093 13.5009C4.96968 13.5009 2.50093 11.0337 2.50093 8.00093Z'
          fill='currentColor'
          fillOpacity='0.7'
        />
      </g>
      <defs>
        <clipPath id='clip0_3255_10642'>
          <rect width='16' height='16' fill='currentColor' />
        </clipPath>
      </defs>
    </svg>
  )
}
